import React from "react";
import { OverPageCTA } from "@design-system/Banner/OverPageCTA";
import { useEnrichmentPausedEntities } from "@hooks/useEnrichmentPausedEntities";
import { useEntities } from "@hooks/useEntities";

export const TransactionEnrichmentPausedBanner: React.FC = () => {
    const pausedEntities = useEnrichmentPausedEntities();
    const businessEntities = useEntities({ onlyBusiness: true });

    if (pausedEntities.length === 0) {
        return null;
    }

    const pausedEntityNames = pausedEntities
        .map((entity) => entity.name)
        .filter((name): name is string => name !== null);
    const shouldListEntityNames =
        businessEntities.length > 1 && pausedEntityNames.length > 0;

    const baseSubtitle =
        "We're preparing your books for categorization. Categorization will resume automatically once it's done.";

    return (
        <OverPageCTA
            title="Transaction categorization is paused"
            subtitle={
                shouldListEntityNames
                    ? `${baseSubtitle} Paused for: ${pausedEntityNames.join(", ")}`
                    : baseSubtitle
            }
        />
    );
};
